import {
  GET_TECHNICALADVISERS,
  GET_TECHNICALADVISERS_FAIL,
  GET_TECHNICALADVISERS_SUCCESS,
  GET_TECHNICALADVISER,
  GET_TECHNICALADVISER_FAIL,
  GET_TECHNICALADVISER_SUCCESS,
  ADD_NEW_TECHNICALADVISER,
  ADD_TECHNICALADVISER_SUCCESS,
  ADD_TECHNICALADVISER_FAIL,
  UPDATE_TECHNICALADVISER,
  UPDATE_TECHNICALADVISER_SUCCESS,
  UPDATE_TECHNICALADVISER_FAIL,
  DELETE_TECHNICALADVISER,
  DELETE_TECHNICALADVISER_SUCCESS,
  DELETE_TECHNICALADVISER_FAIL,
  SET_STATE_TECHNICALADVISER,
  UPDATE_TECHNICALADVISER_CHECK,
  UPDATE_TECHNICALADVISER_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_TECHNICALADVISER,
  payload: loading,
})

export const getTechnicalAdvisers = ( params ) => ({
  type: GET_TECHNICALADVISERS,
  payload: { params },
})

export const getTechnicalAdvisersSuccess = (technicalAdvisers,totalPages, currentPage) => ({
  type: GET_TECHNICALADVISERS_SUCCESS,
  payload: {technicalAdvisers:technicalAdvisers,total:totalPages, currentPage:currentPage}
})

export const getTechnicalAdvisersFail = error => ({
  type: GET_TECHNICALADVISERS_FAIL,
  payload: error,
})

export const addNewTechnicalAdviser = technicalAdvisers => ({
  type: ADD_NEW_TECHNICALADVISER,
  payload: technicalAdvisers,
})

export const addTechnicalAdviserSuccess = technicalAdvisers => ({
  type: ADD_TECHNICALADVISER_SUCCESS,
  payload: technicalAdvisers,
})  

export const addTechnicalAdviserFail = error => ({
  type: ADD_TECHNICALADVISER_FAIL,
  payload: error,
})

export const updateTechnicalAdviser = technicalAdvisers => ({
  type: UPDATE_TECHNICALADVISER,
  payload: technicalAdvisers,
})

export const updateTechnicalAdviserStatus = technicalAdvisers => ({
  type: UPDATE_TECHNICALADVISER_STATUS,
  payload: technicalAdvisers,
})

export const updateTechnicalAdviserSuccess = technicalAdvisers => ({
  type: UPDATE_TECHNICALADVISER_SUCCESS,
  payload: technicalAdvisers,
})

export const updateTechnicalAdviserFail = error => ({
  type: UPDATE_TECHNICALADVISER_FAIL,
  payload: error,
})

export const deleteTechnicalAdviser = technicalAdvisers => ({
  type: DELETE_TECHNICALADVISER,
  payload: technicalAdvisers,
})

export const deleteTechnicalAdviserSuccess = id => ({
  type: DELETE_TECHNICALADVISER_SUCCESS,
  id,
})

export const deleteTechnicalAdviserFail = error => ({
  type: DELETE_TECHNICALADVISER_FAIL,
  payload: error,
})

export const getTechnicalAdviser = () => ({
  type: GET_TECHNICALADVISER,
})

export const getTechnicalAdviserSuccess = technicalAdvisers => ({
  type: GET_TECHNICALADVISER_SUCCESS,
  payload: technicalAdvisers,
})

export const getTechnicalAdviserFail = error => ({
  type: GET_TECHNICALADVISER_FAIL,
  payload: error,
})

export const updateTechnicalAdviserCheck = (id, checkValue) => ({
  type: UPDATE_TECHNICALADVISER_CHECK,
  payload: { id:id, checked:checkValue },
})